import * as types from "./mutations-type";
export default{
    [types.SET_MSG](state,payload){
        state.msg = payload
    },
    [types.SET_TRABALHADOR](state,payload){
        state.trabalhador = payload
    },
    [types.SET_TOMADOR](state,payload){
        state.tomador = payload
    },
    [types.SET_ANIVERSARIO](state,payload){
        state.aniversario = payload
    },
    [types.SET_LISTAHISTORICO](state,payload){
        state.listahistorico = payload
    },
    
}